import { v4 as uuidv4 } from "uuid";
import { CommonNS } from "../../../../../../Common/CommonNS.js";
export const initDOM = (self) => {
  const canvas_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "svg"
  );
  canvas_el.style.backgroundColor = "#F8F9FA";
  canvas_el.setAttributeNS(null, "x", "0");
  canvas_el.setAttributeNS(null, "y", "0");
  canvas_el.setAttributeNS(null, "width", "0");
  canvas_el.setAttributeNS(null, "height", "0");
  canvas_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] = "canvas";
  self._canvas_el = canvas_el;
  const dummy_g_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  dummy_g_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] = "dummy";
  canvas_el.appendChild(dummy_g_el);
  self._dummy_g_el = dummy_g_el;
  const layers_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "svg"
  );
  layers_el.setAttributeNS(null, "x", "0");
  layers_el.setAttributeNS(null, "y", "0");
  layers_el.setAttributeNS(null, "width", "0");
  layers_el.setAttributeNS(null, "height", "0");
  layers_el.setAttributeNS(null, "preserveAspectRatio", "xMidYMid meet");
  layers_el.setAttributeNS(null, "viewBox", "0 0 0 0");
  layers_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] = "layers";
  canvas_el.appendChild(layers_el);
  self._layers_el = layers_el;
  const art_board_layer_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  art_board_layer_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "art-board-layer";
  layers_el.appendChild(art_board_layer_el);
  self._art_board_layer_el = art_board_layer_el;
  const target_image_layer_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  target_image_layer_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "target-image-layer";
  layers_el.appendChild(target_image_layer_el);
  self._target_image_layer_el = target_image_layer_el;
  const hook_layer_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  hook_layer_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] = "hook-layer";
  layers_el.appendChild(hook_layer_el);
  self._hook_layer_el = hook_layer_el;
  const {
    art_board_rect_el,
    art_board_filter_el,
    art_board_filter_drop_shadow_el,
    art_board_shape_path_el,
  } = (() => {
    const art_board_defs_el = self._document.createElementNS(
      CommonNS.ConstNS.SVG_NAMESPACE,
      "defs"
    );
    art_board_layer_el.appendChild(art_board_defs_el);
    const art_board_filter_el = self._document.createElementNS(
      CommonNS.ConstNS.SVG_NAMESPACE,
      "filter"
    );
    art_board_filter_el.setAttributeNS(
      null,
      "id",
      `${CommonNS.ConstNS.DATA_KEY_ROLE}__art-board-filter__${uuidv4()}`
    );
    art_board_filter_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
      "art-board-filter";
    art_board_defs_el.appendChild(art_board_filter_el);
    const art_board_filter_drop_shadow_el = self._document.createElementNS(
      CommonNS.ConstNS.SVG_NAMESPACE,
      "feDropShadow"
    );
    art_board_filter_drop_shadow_el.setAttributeNS(null, "dx", "0");
    art_board_filter_drop_shadow_el.setAttributeNS(null, "dy", "0");
    art_board_filter_drop_shadow_el.setAttributeNS(null, "stdDeviation", "0");
    art_board_filter_drop_shadow_el.setAttributeNS(
      null,
      "flood-color",
      "#000000"
    );
    art_board_filter_drop_shadow_el.setAttributeNS(
      null,
      "flood-opacity",
      "0.05"
    );
    art_board_filter_el.appendChild(art_board_filter_drop_shadow_el);
    const art_board_rect_el = self._document.createElementNS(
      CommonNS.ConstNS.SVG_NAMESPACE,
      "rect"
    );
    art_board_rect_el.setAttributeNS(null, "x", "0");
    art_board_rect_el.setAttributeNS(null, "y", "0");
    art_board_rect_el.setAttributeNS(null, "width", "0");
    art_board_rect_el.setAttributeNS(null, "height", "0");
    art_board_rect_el.setAttributeNS(null, "fill", "none");
    art_board_rect_el.setAttributeNS(null, "stroke", "none");
    art_board_rect_el.setAttributeNS(null, "stroke-width", "0");
    art_board_rect_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] = "art-board";
    art_board_layer_el.appendChild(art_board_rect_el);
    const art_board_shape_path_el = self._document.createElementNS(
      CommonNS.ConstNS.SVG_NAMESPACE,
      "path"
    );
    art_board_shape_path_el.setAttributeNS(null, "d", "M 0 0 Z");
    art_board_shape_path_el.setAttributeNS(null, "fill", "#FFFFFF");
    art_board_shape_path_el.setAttributeNS(null, "stroke", "#E9ECEF");
    art_board_shape_path_el.setAttributeNS(null, "stroke-width", "0");
    art_board_shape_path_el.setAttributeNS(
      null,
      "filter",
      `url(#${art_board_filter_el.id})`
    );
    art_board_shape_path_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
      "art-board-shape";
    art_board_layer_el.appendChild(art_board_shape_path_el);
    return {
      art_board_rect_el,
      art_board_filter_el,
      art_board_filter_drop_shadow_el,
      art_board_shape_path_el,
    };
  })();
  self._art_board_rect_el = art_board_rect_el;
  self._art_board_filter_el = art_board_filter_el;
  self._art_board_filter_drop_shadow_el = art_board_filter_drop_shadow_el;
  self._art_board_shape_path_el = art_board_shape_path_el;
  const target_image_dummy_g_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  target_image_dummy_g_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "target-image-dummy-g";
  self._target_image_dummy_g_el = target_image_dummy_g_el;
  const hook_g_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  self._hook_g_el = hook_g_el;
  hook_g_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] = "hook-g";
  hook_g_el.setAttributeNS(null, "transform", "translate(0 0)");
  hook_layer_el.appendChild(hook_g_el);
  const hook_empty_path_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "path"
  );
  self._hook_empty_path_el = hook_empty_path_el;
  hook_empty_path_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "hook-empty-path";
  hook_empty_path_el.setAttributeNS(
    null,
    "d",
    ["M 0 0", "A 0 0 180 1 1 0 0", "A 0 0 180 1 1 0 0", "Z"].join(" ")
  );
  hook_empty_path_el.setAttributeNS(null, "fill", `none`);
  hook_empty_path_el.setAttributeNS(null, "stroke", `none`);
  hook_empty_path_el.setAttributeNS(null, "visibility", `visible`);
  hook_empty_path_el.setAttributeNS(null, "cursor", `pointer`);
  hook_empty_path_el.setAttributeNS(null, "pointer-events", `visibleFill`);
  hook_g_el.appendChild(hook_empty_path_el);
  const hook_path_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "path"
  );
  self._hook_path_el = hook_path_el;
  hook_path_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] = "hook-path";
  hook_path_el.setAttributeNS(
    null,
    "d",
    [
      "M 0 0",
      "A 0 0 180 1 1 0 0",
      "A 0 0 180 1 1 0 0",
      "M 0 0",
      "A 0 0 180 1 0 0 0",
      "A 0 0 180 1 0 0 0",
      "Z",
    ].join(" ")
  );
  hook_path_el.setAttributeNS(null, "fill", `#FE00FF`);
  hook_path_el.setAttributeNS(null, "fill-rule", `nonzero`);
  hook_path_el.setAttributeNS(null, "stroke", `none`);
  hook_path_el.setAttributeNS(null, "cursor", `pointer`);
  hook_path_el.setAttributeNS(null, "pointer-events", `fill`);
  hook_g_el.appendChild(hook_path_el);
};
